import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DeliveryTable from "./DeliveryTable";
import { useStats } from "../Departure/useDeparture";
import { useSelector } from "react-redux";

const DeliveryViewContent = () => {
  const { t } = useTranslation("common");
  const { getStats } = useStats();
  const { user } = useSelector((state) => state.userReducer);
  const [stats, setStats] = useState([]);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        if (user?.attributes?.userRole === 0) {
          const [incident, ready, delivery, delivered] = await Promise.all([
            getStats("APPROV"),
            getStats("ORDER"),
            getStats("DELIVERY"),
            getStats(["DELIVERED", "INVOICE"]),
          ]);

          setStats([
            { label: t("Order in supply"), value: incident, color: "#ff3131" },
            {
              label: t("Order pending delivery arrangement"),
              value: ready,
              color: "#ff5757",
            },
            { label: t("In delivery"), value: delivery, color: "#c9762e" },
            {
              label: `${t("Delivered in")} ${new Date().getFullYear()}`,
              value: delivered,
              color: "#00bf63",
            },
          ]);
        } else {
          const [incident, ready, delivery, delivered] = await Promise.all([
            getStats("INCIDENT"),
            getStats("READY"),
            getStats("DELIVERY"),
            getStats(["DELIVERED", "INVOICE"]),
          ]);

          setStats([
            { label: t("Incident"), value: incident, color: "#ff3131" },
            { label: t("To validate pickup"), value: ready, color: "#ff5757" },
            { label: t("In delivery"), value: delivery, color: "#c9762e" },
            {
              label: `${t("Delivered in")} ${new Date().getFullYear()}`,
              value: delivered,
              color: "#00bf63",
            },
          ]);
        }
      } catch (error) {
        console.error("Failed to fetch stats:", error);
      }
    };

    fetchStats();
  }, [t]);

  return (
    <div className="">
      <p className="text-blue bold f30 quickSand">{t("Delivery")}</p>
      <div className="d-flex flex-wrap gap-4 mb-5">
        {stats.map((stat) => (
          <div
            className="d-flex flex-column p-4 flex-1 max-w-300px"
            style={{
              backgroundColor: stat.color,
              borderRadius: "10px",
            }}
          >
            <p className="f20 sBold text-white mb-2">{stat.label}</p>
            <p className="f18 sBold text-white">{stat.value}</p>
          </div>
        ))}
      </div>
      <DeliveryTable />
    </div>
  );
};

export default DeliveryViewContent;
